import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/assetDepreciations/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/assetDepreciations/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/assetDepreciations/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/assetDepreciations/delete',
    method: 'post',
    data
  })
}

export function deleteByYearMonth(yearMonth) {
  return request({
    url: '/assetDepreciations/deleteByYearMonth',
    method: 'post',
    data: JSON.stringify(yearMonth),
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

